import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import { RouteLoader } from "./components/layout/RouteLoader";

export const getRouter = () => {
  const queryClient = new QueryClient();

  const router = createRouter({
    routeTree,
    context: { queryClient },
    scrollRestoration: true,
    // Intent-based prefetch: hovering/focusing a <Link> for 40ms starts the
    // route load, so the click usually lands on already-warm code + data.
    defaultPreload: "intent",
    defaultPreloadDelay: 40,
    defaultPreloadStaleTime: 0,
    defaultPreloadGcTime: 5 * 60_000,
    defaultPendingComponent: RouteLoader,
    defaultPendingMs: 100,
    trailingSlash: "always",
  });

  return router;
};
